/** @format */

import React from "react";
import Styles from "./Loader.module.css";

const Loader = () => {
  return (
    <div className={Styles.loader}>
      <div className={`${Styles.lsparticles} ${Styles.lspart1}`}></div>
      <div className={`${Styles.lsparticles} ${Styles.lspart2}`}></div>
      <div className={`${Styles.lsparticles} ${Styles.lspart3}`}></div>
      <div className={`${Styles.lsparticles} ${Styles.lspart4}`}></div>
      <div className={`${Styles.lsparticles} ${Styles.lspart5}`}></div>
      <div className={`${Styles.lightsaber} ${Styles.lsleft} ${Styles.lsgreen}`}></div>
      <div className={`${Styles.lightsaber} ${Styles.lsright} ${Styles.lsred}`}></div>
    </div>
  );
};

export default Loader;
